export default __webpack_public_path__ + "static/gt-haptik-medium-rotalic-500.latin-96d9e52acf9f6f8ef01963deaa892023.woff2";